import { render, staticRenderFns } from "./MobilePopup.vue?vue&type=template&id=5c2de4a6&scoped=true"
import script from "./MobilePopup.vue?vue&type=script&lang=js"
export * from "./MobilePopup.vue?vue&type=script&lang=js"
import style0 from "./MobilePopup.vue?vue&type=style&index=0&id=5c2de4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2de4a6",
  null
  
)

export default component.exports